export default {
    name: '資格名',
    sortno: '並び順',
    gyoshu: '該当建設業種別'
};
